module.exports = __webpack_public_path__ + "static/globe-dark-4c3006ef84fef1822b4f82338f174edd.gif";